import type { TProperty } from 'stores/fieldAssetStore/helperTypes'
import { checkAuthorization } from 'utils/checkAuthorization'

export const hasWaterMonitoringAssets = (property: TProperty): boolean =>
  Object.keys(property.irrigationZoneEmitters ?? {}).length > 0 ||
  (checkAuthorization({ permission: 'VIEW_SOIL_MOISTURE_DETAILS', entity: property.propertyId }) &&
    Object.values(property.points ?? {}).some((point) =>
      (point.valuesTimeseries ?? []).some((valueType) => valueType === 'soilMoisture'),
    ))
